import { Box, CircularProgress, Typography } from "@mui/material";
import CompareIcon from "@mui/icons-material/Compare";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import React from "react";

export const ComparisonChart = ({ data, loading }) => {
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 300,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <CompareIcon sx={{ mr: 1, color: "info.main" }} />
        <Typography variant="h6">Comparação com o Mês Anterior</Typography>
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Mês Atual vs Mês Passado
      </Typography>

      <Box sx={{ height: 300 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip
              formatter={(value) => [`R$${value.toLocaleString()}`, ""]}
            />
            <Legend />
            <Bar dataKey="thisMonth" name="Mês Atual" fill="#8884d8" />
            <Bar dataKey="lastMonth" name="Mês Anterior" fill="#82ca9d" />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </>
  );
};
